import { axiosGetAuthorize, // TO DO unused import // TO DO lazy load component 
    axiosPostAuthorize } from '../AxiosRequests';
import { UpdatePurityInquiryResponse } from '../ApiEndPoints';

export default class InquiryResponseProductDetailServices {

    //** Call API : */
    async updatePurityInquiryResponse(request) {
        return axiosPostAuthorize(UpdatePurityInquiryResponse, request);
    }
}
